/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_LegendInputs */

const en_us2_workout_quick_effort_legend = /** @type {(inputs: Workout_Quick_Effort_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effort on this exercise · optional`)
};

const pt_br2_workout_quick_effort_legend = /** @type {(inputs: Workout_Quick_Effort_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esforço neste exercício · opcional`)
};

const es_419_workout_quick_effort_legend = /** @type {(inputs: Workout_Quick_Effort_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esfuerzo en este ejercicio · opcional`)
};

const pt_pt2_workout_quick_effort_legend = /** @type {(inputs: Workout_Quick_Effort_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esforço neste exercício · opcional`)
};

const fr_fr2_workout_quick_effort_legend = /** @type {(inputs: Workout_Quick_Effort_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effort sur cet exercice · facultatif`)
};

const de_de2_workout_quick_effort_legend = /** @type {(inputs: Workout_Quick_Effort_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anstrengung bei dieser Übung · optional`)
};

const it_it2_workout_quick_effort_legend = /** @type {(inputs: Workout_Quick_Effort_LegendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sforzo in questo esercizio · facoltativo`)
};

/**
* | output |
* | --- |
* | "Effort on this exercise · optional" |
*
* @param {Workout_Quick_Effort_LegendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_legend = /** @type {((inputs?: Workout_Quick_Effort_LegendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_LegendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_legend(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_legend(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_legend(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_legend(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_legend(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_legend(inputs)
	return en_us2_workout_quick_effort_legend(inputs)
});
export { workout_quick_effort_legend as "workout-quick.effort_legend" }